import { Route, Routes } from 'react-router-dom';
import './App.css';
import SignIn from './components/SignIn';
import Dashboard from './components/Dashboard/Dashboard';
import AllSubscriptionTable from './components/Dashboard/AllSubscriptionTable';
import './assets/css/main.scss';
import 'boxicons/css/boxicons.min.css';

import ContactFilterCategories from './components/Search/ContactFilterCategories';
import SavedSearches from './components/Search/SavedSearches/SavedSearches';
import UploadReport from './components/Report/UploadReport/UploadReport';
import DataCount from './components/Report/DataCount/DataCount';
import Flagged from './components/Settings/Flagged/Flagged';
import UploadCSV from './components/Settings/UploadCSV/UploadCSV';
import Users from './components/Settings/Users/Users';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Profile from './components/Navbar/Profile';
import ViewedContacts from './components/Search/ViewedContacts/ViewedContacts';
import Trash from './components/Settings/Trash/Trash';
import ResetPassword from './components/Navbar/ResetPassword';
import ForgetPassword from './components/ForgetPassword';
import SignUp from './components/SignUp';
import MyList from './components/Search/MyList/MyList';

import RaiseRequest from './components/Request/RaiseRequest';
import Sample from './components/Request/Sample';
import Project from './components/Request/Project';

import LinkedinLogin from './components/LinkedinCallback/LinkedinLogin';
import GoogleLoginPage from './components/GoogleLogin/GoogleLoginPage';

function App() {
  const login = sessionStorage.getItem("login");
  const expiryStatus = sessionStorage.getItem("expiryStatus");

  console.log(expiryStatus, "expiryStatus")

  return (
    <div className="App" style={{ height: '100vh' }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={login ? <Dashboard /> : <SignIn />} />
        <Route path="/dashboard" element={login ? <Dashboard /> : <SignIn />} />
        <Route path="/allSubscription" element={login && !expiryStatus ? <AllSubscriptionTable /> : <SignIn />} />
        <Route path="/contact-filter" element={login && !expiryStatus ? <ContactFilterCategories /> : <SignIn />} />
        <Route path="/saved-searches" element={login && !expiryStatus ? <SavedSearches /> : <SignIn />} />
        <Route path="/upload-reports" element={login && !expiryStatus ? <UploadReport /> : <SignIn />} />
        <Route path="/data-count" element={login && !expiryStatus ? <DataCount /> : <SignIn />} />
        <Route path="/flagged-contacts" element={login && !expiryStatus ? <Flagged /> : <SignIn />} />
        <Route path="/upload-csv" element={login && !expiryStatus ? <UploadCSV /> : <SignIn />} />
        <Route path="/users" element={login && !expiryStatus ? <Users /> : <SignIn />} />
        <Route path="/profile" element={login ? <Profile /> : <SignIn />} />
        <Route path="/viewed-contacts" element={login && !expiryStatus ? <ViewedContacts /> : <SignIn />} />
        <Route path="/trash" element={login && !expiryStatus ? <Trash /> : <SignIn />} />
        <Route path="/my-list" element={login && !expiryStatus ? <MyList /> : <SignIn />} />
        <Route path="/raiserequest" element={login && !expiryStatus ? <RaiseRequest /> : <SignIn />} />
         <Route path="/project" element={login && !expiryStatus ? <Project /> : <SignIn />} />
          <Route path="/sample" element={login && !expiryStatus ? <Sample /> : <SignIn />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/signup" element={login ? <Dashboard /> : <SignUp />} />
         
          {/* <Route path="/linkedinlogin" element={login ? <LinkedinLogin /> : <LinkedinLogin />} /> */}
          <Route path="/linkedinlogin" element={<LinkedinLogin />} />

          <Route path="/google-login" element={login ? <GoogleLoginPage /> : <GoogleLoginPage />} />
      </Routes>
    </div>
  );
}

export default App;
